<div [appLoadingAnimation]="!isLoaded" class="cms-page__content" [attr.data-test]="'feature-terms'">
  <div class="container">
    @if (isLoaded) {
      <div class="logo logo--compact terms-logo"></div>
      <h2 class="logo-color" [innerHTML]="cmsPageData.attributes.title"></h2>
      <div [innerHTML]="pageContent"></div>
      @if (userLoggedIn && !userAccepted && isOnToU) {
        <button id="btnAcceptToU" type="submit" (click)="onClickAccept()" class="button button--primary" [disabled]="!onScroll() || isAccepting">
          {{ 'terms.accept' | translate }}
        </button>
        <button id="btnRejectToU" type="submit" (click)="onClickReject()" class="button button--secondary">
          {{ 'terms.reject' | translate }}
        </button>
      }
    }
  </div>
</div>
